import CustomersTable from '@/components/customers/CustomersTable';

const CustomersPage = () => {
  return (
    <div className="px-4 py-6">
      <CustomersTable />
    </div>
  );
};

export default CustomersPage;
